import { parsedUser } from "../common/GetCurrentUser"
import RecordContainer from "../components/Record/RecordContainer"
import { Routes } from "../routes"

const RecordPage = () => {
    const user = parsedUser();
    if (user === null) {
        window.location.href = Routes.SignIn.path
        return null
    }
    return (

        <RecordContainer />

    )
}

export default RecordPage